export default "__VITE_ASSET__Cj8tVHRG__"